export default "__VITE_PUBLIC_ASSET__a7daa9b9__"